<template>
    <div class="metafund">
        <div class="metafund-head show-page">
            <div class="t1 bold bounceUpIn">METAfund</div>
        </div>
        <div class="metafund-body">
            <div class="metafund-left show-page">
                <img class="track track-anim" src="@/assets/index/metafund/track.png" alt="">

                <div class="center-rotate-box">
                    <div class="scaleing"> <img class="center zoomInBack" :style="getDt(2)" src="@/assets/index/metafund/c1.png" alt=""> </div>
                </div>
                <div class="rotate-box">
                    <div class="planet-box revolutionS" :style="getResDt(80)"> <img class="cno-1 zoomInBack" :style="getDt(10)" src="@/assets/index/metafund/circle1.png" alt=""> </div>
                </div>
                <div class="rotate-box">
                    <div class="planet-box revolutionN" :style="getResDt(10)"> <img class="cno-2 zoomInBack" :style="getDt(11)" src="@/assets/index/metafund/circle2.png" alt=""> </div>
                </div>
                <div class="rotate-box">
                    <div class="planet-box revolutionS" :style="getResDt(40)"> <img class="cno-3 zoomInBack" :style="getDt(7)" src="@/assets/index/metafund/circle3.png" alt=""> </div>
                </div>
                <div class="rotate-box">
                    <div class="planet-box revolutionS" :style="getResDt(30)"> <img class="cno-4 zoomInBack" :style="getDt(12)" src="@/assets/index/metafund/c2.png" alt=""> </div>
                </div>
                <div class="rotate-box">
                    <div class="planet-box revolutionN" :style="getResDt(60)"> <img class="cno-5 zoomInBack" :style="getDt(3)" src="@/assets/index/metafund/c3.png" alt=""> </div>
                </div>
                <div class="rotate-box">
                    <div class="planet-box revolutionS" :style="getResDt(40)"> <img class="cno-6 zoomInBack" :style="getDt(6)" src="@/assets/index/metafund/c4.png" alt=""> </div>
                </div>
                <div class="rotate-box">
                    <div class="planet-box revolutionN" :style="getResDt(25)"> <img class="cno-7 zoomInBack" :style="getDt(14)" src="@/assets/index/metafund/c5.png" alt=""> </div>
                </div>
            </div>
            <div class="metafund-right show-page">
                <div class="h1 bold bounceUpIn" :style="getDt(1)">Empowering The Metaverse</div>
                <div class="h2 bounceUpIn" :style="getDt(2)">MOBOX invests in technical teams that build and support The Metaverse.</div>
                <br />
                <br />
                <div class="h2 bounceUpIn" :style="getDt(3)">The METAfund is an incubation fund in collaboration with <span class="bold" style="color:#EFB513">Binance NFT Marketplace</span> on the decision committee.  The Metafund is committed to supporting  game developers in bringing their great games to the blockchain and MOMOverse.</div>
                <br />
                <br />
                <div class="h2 bounceUpIn" :style="getDt(4)" style="font-weight:bold;color:#EFB513">Projects Incubated 5</div>

                <div @click="toApply" class="bounceUpIn" :style="getDt(5)">
                    <div class="apply-btn btn-1">Apply now</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            metafund:0,
            metafunddt:0.1,
        }
    },
    
    methods:{
        toApply(){
            window.open(`https://forms.gle/yRQ5Ehcwk5PwcXGt6`);
        },
        getDt(idx){
            return `animation-delay:${this.metafund + this.metafunddt*idx}s`
        },

        getResDt(ts){
            return `animation-duration:${ts}s`
        }
    }
}
</script>

<style lang="less" scoped>
    .pageIn{
        .track-anim{
            opacity: 0;

            animation-name: landRotateInS, revolutionS;
            animation-duration: 2s, 20s;
            animation-timing-function:ease, linear;
            animation-delay:1s, 2.9s;
            animation-iteration-count:1, infinite;
            animation-fill-mode:forwards, none;
        }
    }

    .metafund{
        background: url(../../assets/index/momoverse/bg1.png) no-repeat;
        background-size: inherit;
        margin-top: -94px;
        padding: 170px 0 220px 0;
        position: relative;

        color: white;

        .metafund-head{
            text-align: center;
            margin-bottom: 70px;
        }

        .track-anim{
            opacity: 0;
        }

        .metafund-body{
            display: flex;
            align-items: center;
            justify-content: space-between;

            width: 80%;
            margin: auto;

            .metafund-left{
                width: 50%;
                position: relative;

                .track{
                    width: 100%;
                }

                .center-rotate-box{
                    position: absolute;
                    top: 49.5%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 45%;

                    .center{
                        width: 100%;
                        height: 100%;
                    }
                }

                .rotate-box{
                    width: 10%;
                    height: 10%;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
    
                    .planet-box{
                        width: 100%;
                        height: 100%;
    
                        .cno-1{
                            left: -320%;
                            bottom: 290%;
                            position: absolute;
                            width: 100%;
                        }
                        .cno-2{
                            right: -360%;
                            bottom: 30%;
                            position: absolute;
                            width: 100%;
                        }
                        .cno-3{
                            right: -490%;
                            bottom: 30%;
                            position: absolute;
                            width: 80%;
                        }
                        .cno-4{
                            left: -320%;
                            top: 165%;
                            position: absolute;
                            width: 230%;
                        }
                        .cno-5{
                            left: -230%;
                            top: -290%;
                            position: absolute;
                            width: 200%;
                        }
                        .cno-6{
                            left: 160%;
                            top: -350%;
                            position: absolute;
                            width: 180%;
                        }
                        .cno-7{
                            left: 180%;
                            top: 230%;
                            position: absolute;
                            width: 190%;
                        }
                    }
                }

            }

            .metafund-right{
                width: 40%;

                .apply-btn{
                    margin-top: 50px;
                }
            }

        }
    }
</style>